export const HEADER_MAIN_OFFSET = 16;
